import { METHOD } from './method'

export const API_ORDER = {
    COMPARISON: {
        api: '/v1/dashboard-admin/analytic/order/comparison',
        method: METHOD.POST,
    },
    GRAPH: {
        api: '/v1/dashboard-admin/analytic/order/graph',
        method: METHOD.POST,
    },
    LIST: {
        api: '/v1/dashboard-admin/analytic/order/list',
        method: METHOD.POST,
    },
    VOUCHER_LIST: {
        api: '/v1/dashboard-admin/analytic/order/vouchers',
        method: METHOD.GET,
    },
    SHIPPING_METHODS: {
        api: '/v1/master/shipping-methods',
        method: METHOD.GET,
    },
    PAYMENT_METHODS: {
        api: '/v1/master/payment-methods',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/analytic/order/export',
        method: METHOD.POST,
    },
}
